import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Box, Button, IconButton, TextField, CircularProgress } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import NakdanButton from "../../SharedArea/NakdanButton";
import { observer } from "mobx-react-lite";
import additionalInfo from "../../../Mobx/AdditionalInfo";

const NewStorySection = observer(() => {
    const newInfo = additionalInfo.newInfo;
    const expanded = additionalInfo.expandedState;
    const loading = additionalInfo.loading;

    const handleToggle = () => {
        additionalInfo.setExpandedState({ ...expanded, stories: !expanded.stories });
    };

    return (
        <Grid item xs={12}>
            <Accordion expanded={expanded.stories} onChange={() => handleToggle("stories")} sx={{ boxShadow: 3, borderRadius: 2, width: "100%" }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">({newInfo.story?.length || 0}) יצירת סיפורים</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ width: "100%", textAlign: "center" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => additionalInfo.createWithAi("story")}
                        sx={{ mb: 2 }}
                        disabled={loading.create.story}
                    >
                        {loading.create.story ? <CircularProgress size={24} /> : "צור"}
                    </Button>
                    <Box>
                        {newInfo.story?.length > 0 ? (
                            newInfo.story.map((story, index) =>
                                <Box key={index} sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", bgcolor: "#f0f0f0", p: 1, borderRadius: 2, mt: 0.5 }}>
                                    <Box sx={{ display: "flex", gap: 0, ml: 1 }}>
                                        {/* כפתור ניקוד */}
                                        <NakdanButton
                                            text={story}
                                            onNikudComplete={(nikudText) => {
                                                additionalInfo.editNewInfo("story", index, nikudText);
                                            }}
                                        />
                                        {/* כפתור שמירה */}
                                        <IconButton
                                            onClick={() =>
                                                additionalInfo.addExistsInfo({
                                                    fields: { story },
                                                    field: "stories",
                                                    index
                                                })
                                            }
                                            disabled={additionalInfo.loading.addExistsInfo.stories?.[index]}
                                        >
                                            {story && (additionalInfo.loading.addExistsInfo.stories?.[index] ? <CircularProgress size={24} /> : <SaveIcon color="primary" />)}
                                        </IconButton>
                                        {/* כפתור מחיקה */}
                                        <IconButton onClick={() => additionalInfo.deleteNewInfo("story", index)}>
                                            <DeleteIcon color="error" />
                                        </IconButton>
                                    </Box>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        multiline
                                        minRows={1}
                                        value={story}
                                        onChange={(e) => additionalInfo.editNewInfo("story", index, e.target.value)}
                                        sx={{ direction: /^[\u0590-\u05FF]/.test(story) ? "ltr" : "rtl" }}
                                    />
                                </Box>
                            )
                        ) : (
                            <Typography variant="body2" color="textSecondary">לא נוצרו סיפורים</Typography>
                        )}
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
});

export default NewStorySection;
